import { useLayoutEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setCursor } from '../state/actions/ui/cursorTables';
import { CLEARED_TABLE_FILTERS } from '../components/display/tables/clearedTableFilters';

/**
 * Vacía el cursor de la tabla de un modal y dice cuándo se puede pintar.
 *
 * Los modales de vincular (OT ↔ recorrido/tramo) comparten un cursor GLOBAL de
 * Redux entre aperturas, y además persistido. Vaciarlo en un `useEffect` del
 * modal llega tarde: los efectos de la tabla hija corren antes, y los campos
 * Expediente e Índice cogen su valor UNA vez, al montarse. Resultado: el campo
 * enseñaba el expediente de la vez anterior y la lupa lo volvía a aplicar.
 *
 * Por eso el modal no pinta la tabla hasta que esto devuelve `true`. Es un
 * `useLayoutEffect`: el segundo render ocurre antes de que el navegador pinte,
 * así que no hay parpadeo.
 */
export function useFreshTableCursor(tableId: string): boolean {
  const dispatch = useDispatch();
  const [isFresh, setIsFresh] = useState(false);

  useLayoutEffect(() => {
    dispatch(setCursor(tableId, { cursor: '', ...CLEARED_TABLE_FILTERS }));
    setIsFresh(true);
  }, [dispatch, tableId]);

  return isFresh;
}
